import { createContext, useContext, useState } from "react";

const AppContext = createContext();
export const useApp = () => useContext(AppContext);

export const AppProvider = ({ children }) => {
  const [notificationCreativePayload, setNotificationCreativePayload] = useState(null);

  return (
    <AppContext.Provider
      value={{
        notificationCreativePayload, 
        setNotificationCreativePayload
      }}
    >
      {children}
    </AppContext.Provider>
  );
};
